module.exports = __webpack_public_path__ + "img/basic_skinwashd_skinwashtube_202309.20964ace.jpg";